import axios from 'axios';


export default {
  info () {
    return axios.get('/system/info')
      .then(response => response.data);
  }
};
